module.exports = __webpack_public_path__ + "static/media/01.9667f2ae.jpg";